class LoansService {

  constructor(LoansUserDataService, LoansInitialDataService) {
    'ngInject';
    this.initialDataService = LoansInitialDataService;
    this.userDataService = LoansUserDataService;
    this.loaded = false;
  }

  loadEmployeeProfileInfoAndData() {
    this.initialDataService.getEmployeeProfileInfo().then(() => {
      this._loadData();
    });
  }

  _loadData() {
    if (!this.userDataService.isEmpty()) {
      return;
    }

    this.initialDataService.initMainData().then((employee) => {
      if (!employee) return;
      this.employee = employee;
      this.loaded = true;
      return employee;
    }, (err) => {
      this.employee = {};
      throw(err);
    });
  }
}

export default LoansService;



// WEBPACK FOOTER //
// ./client/app/loans.module/loans.service.js